import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.65, ease: [0.2, 0.8, 0.2, 1] },
  },
};

export default function ScrollReveal({ children, delay = 0, ...props }) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.16, margin: "0px 0px -40px" }}
      variants={prefersReducedMotion ? undefined : reveal}
      transition={prefersReducedMotion ? undefined : { delay }}
      {...props}
    >
      {children}
    </motion.div>
  );
}
